import * as React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Loading from 'components/Loading';
import Flex from 'ui/Flex/Flex';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { BudgetProposalRow, BudgetStateColumn } from './types';

const BudgetStatesCellRenderer = ({
    data,
    colId,
}: CellRendererParams<BudgetProposalRow> & {
    colId: BudgetStateColumn;
}): JSX.Element => {
    if (data === undefined) {
        return <Loading />;
    }

    const components = {
        budget: (
            <Typography color="primary" fontWeight={600}>
                {data.budget}
            </Typography>
        ),
        exercise: <Typography color="textPrimary">{data.exercise}</Typography>,
        phase: <Typography color="textPrimary">{data.phase}</Typography>,
    };

    return (
        <Link to={data.redirectTo}>
            <Flex alignItems="center" sx={{ height: '100%' }}>
                {components[colId]}
            </Flex>
        </Link>
    );
};

export default BudgetStatesCellRenderer;
